import cn from 'classnames';
import styles from './Icons.scss';
import React from 'react';
import { Icons, IconProps } from './IconsRes';
import { getIconClasses } from '@/Static/IconUtils';

export const WarningIcon = ({ id, size = 'small', onClick, className, disabled }: IconProps) => {
  return (
    <img
      id={id}
      src={Icons.AddressWarning}
      alt="img"
      className={cn(styles.icon, className, getIconClasses(size))}
      onClick={() => {
        if (!disabled) onClick?.();
      }}
    />
  );
};
